<template lang="pug">
  div#theInfo
    v-container( fluid )
      v-row
        v-col.align-center(cols="12")
          .headline.my-1
            u City of Refuge UCC
      v-row
        v-col.align-center(cols="12")
          .title Join Us 
            span.bibleStudyInfo.infoUnderline {{getSunday}}
      v-row
        v-col(cols="12")
          .body-1Intercessory Prayer - 10:30am
      v-row
        v-col(cols="12")
          .body-1Sunday Service - 11:00am
      v-row
        v-col(cols="12")
          .subtitle-1.bibleStudyInfo 
            | Bible Study - 
            u 1st Tuesdays
            |  at 7pm
      v-row
        v-col(cols="12")
          .body
            v-icon.mdi.mdi-map-marker(small)  
            |  8400 Enterprise Way
            <br> Oakland, CA 94621
      v-row
        v-col(cols="12")
          .body
            v-icon.mdi.mdi-phone(small)
            |  (510) 633-6316
      v-row
        v-col(cols="12")
          .body
            v-tooltip(top)
              template(v-slot:activator='{ on }')
                p.mt-1(v-on="on") 
                  v-icon.mdi.mdi-fax(small)   
                  |  (510) 633-6331
              | Fax Number
      v-row
        v-col(cols="12")
          .body
            v-icon.mdi.mdi-email(small)
            v-btn.px-1(text href="mailto:info@cityofrefugeucc.org")  info@cityofrefugeucc.org
      v-row
        v-col(cols="12")
          .title.lineHeight Bishop Yvette Flunder,
            br
            | Founder & Senior Pastor
</template>

<script>
import { getSunday } from '../../plugins/getDays';
export default {
  created() {
    this.getSunday = getSunday();
  }
};
</script>

<style lang="stylus" scoped>
.col.col-12
  padding 1px

.lineHeight
  line-height 1.25rem !important

#theInfo
  .title
    font-family Montserrat, Arial, Sans-Serif !important

.infoUnderline
  text-decoration underline

.bibleStudyInfo
  color #D9AB23
</style>
